import React, { useState, useEffect, useCallback } from "react";
import config from "../appconfig/config.json";
import {FormSubTitleDespHybrid,  FormTitleHybrid, HybridFormLabelGrey } from "../validation/Form-Components";
import { Field, FieldWrapper, Form, FormElement } from "@progress/kendo-react-form";
import FinancingSelection from "../hybridcomponents/FinancingSelection";
import mData from '../hybriddata/mainform.json';
import RdoFinancingType from "../hybridcomponents/RdoFinacingType";
import PromoCodeSelection from "../hybridcomponents/PromoCodeSelection";
import ReCAPTCHA from "react-google-recaptcha";  //commented 
import { Button } from "@progress/kendo-react-buttons";
import CusToast from "../components/CusToast";
import PersonalisedBizFinancing from "./PersonalisedBizFinancing";
import EnterpriseDeclarePopup from "../hybridcomponents/EnterpriseDeclarePopup";
import SingpassDeclarePopup from "../hybridcomponents/SingpassDeclarePopup";
import ChkIslamicFType from "../hybridcomponents/ChkIslamicFType";
import 'react-rangeslider/lib/index.css';
import RangeSlider from 'react-bootstrap-range-slider';
import { NumericTextBox } from '@progress/kendo-react-inputs';
import BlueboxTextList from "../hybridcomponents/BlueboxTextList";
import TenureSelection from "../hybridcomponents/TenureSelection";
import service from '../services/ApiService.js';
import servicestate from '../services/StateApiService.js';
import storage from '../factory/StorageFactory';
import Loading from "../components/Loading";
import { useHistory } from "react-router-dom";
import { useLocation } from "react-router-dom/cjs/react-router-dom.js";
import helper from '../factory/Helper.js';
import FormContainerMax from "../components/FormContainerMax.jsx";
import {min200KValidator } from "../validation/Validators.jsx";
import TotalFinancingAmt from "../hybridcomponents/TotalFinancingAmt.jsx";
import OTPDisclaimer from "../hybridcomponents/OTPDisclaimer.jsx";
import BTLDisclaimerPopup from "../hybridcomponents/BTLDisclaimerPopup.jsx";
import HybridDisclaimerPopup from "../hybridcomponents/HybridDeclarePopup.jsx";
import AIPDisclaimerPopup from "../hybridcomponents/AIPDisclaimerPopup.jsx";

let createdStateRes = {};
const MainFinanceDetails = (props) => {

    let timer;
    const history = useHistory();
    const location = useLocation(); //window.location.pathname

    const [showPromoReferalDiv2, setShowPromoReferalDiv2] = useState(false);
    const [isEditPreview,setIsEditPreview] = useState(false);
    const [isLoading, setIsLoading] = useState(false); //default true
    const [isError, setIsError] = useState(false);
    const [errMsg, setErrMsg] = useState("");
 
    const [captchaResult, setCaptchaResult] = useState(false); //Google recaptcha value

    const [selectedRdoFinancingType, setSelectedRdoFinancingType] = useState(mData.financeTypeRdo.Conventional); //Conventional/islamic
    const [disabledRdoFinancingType, setDisabledRdoFinancingType] = useState(true);

    //Online Biz Financing
    const [maxAmountVal, setmaxAmountVal] = useState(mData.STPFinancingAmt.max);
    const [SlidervalueMin, setAmountsSliderValueMin] = useState(mData.STPFinancingAmt.min);
    const [SlidervalueMax, setAmountsSliderValueMax] = useState(mData.STPFinancingAmt.max);

    const [showTenureSelection, setShowTenureSelection] = useState(null);
    const [selectedTenureCard, setSelectedTenureCard] = useState({tenure:'',estMonthlyInstallment:''});
    const [estMonthInstT1Value, setEstMonthInstT1Value] = useState("");
    const [estMonthInstT2Value, setEstMonthInstT2Value] = useState("");
    const [estMonthInstT3Value, setEstMonthInstT3Value] = useState("");
    const [estMonthInstT4Value, setEstMonthInstT4Value] = useState("");
    const [estMonthInstT5Value, setEstMonthInstT5Value] = useState("");

    //Interest Rate Slider
    const [interestRateVal, setInterestRateVal] = useState(mData.STPInterestRate.min); //def set to min
    const [interestRateSliderVal, setinterestRateSliderVal] = useState(mData.STPInterestRate.min); // def set to min

    //Online Biz Financing End

    //AIP
    const [selectedRdoExistingOTP, setSelectedRdoExistingOTP] = useState(null);
    //AIP End
 
    const [tfAmtValue,setTFAmtValue] = useState(null);

    const [selectedBizFinancing,setSelectedBizFinancing] = useState(null);
    const [showEnterpriseDeclarePopup,setShowEnterpriseDeclarePopup] = useState(false);
    const [showSingpassDeclarePopup,setShowSingpassDeclarePopup] = useState(false);

    const [showBtlDeclarePopup,setShowBtlDeclarePopup] = useState(false);
    const [showHybridDeclarePopup,setShowHybridDeclarePopup] = useState(false);
    const [showAipDeclarePopup,setShowAipDeclarePopup] = useState(false);

    const [initFormData,setInitFormData] = useState({
        chkWorkingCapital:false,
        chkProperty:false,
        chkTrade:false,
        chkGovAssist:false,
        chkESG:false,
        totalFinancingAmtValue:null,
        ddlPromoReferal1:mData.promoReferalDDList[0],
        promoReferalValue1:'',
        ddlPromoReferal2:null,
        promoReferalValue2:'',
        chkIsamicFtypeDeclare:false
    })

    const [formData, setFormData] = useState();

    const [isFromESG,setIsFromESG] = useState(false);
    const [esgSolutionFType,setESGSolutionFType] = useState('');

    useEffect(() => {

        console.log('@MainFinance useEffect');
        getInfofromQueryString();
        return () => {
            clearTimeout(timer);
        }
    }, []);

    const getInfofromQueryString= () => {  
      const queryString = require('query-string');
      const parsed = queryString.parse(props.location.search);
 
      let optionValue = parsed.option;
      let srcValue = parsed.psrc;
      let esgSolutionValue = parsed.pft;


      //Edit from Preview
      let rno = parsed.refNo;
      if(rno === undefined || rno === null || rno=== '') { //create application
        storage.clearAll();
        setIsEditPreview(false);
        postSecurity();
        if(optionValue && srcValue) { //this is from ESG Solution Page
          //check for auto select
          // console.log('getInfofromQueryString',optionValue, srcValue);
          setIsFromESG(true);
          if(esgSolutionValue) {
            setESGSolutionFType(esgSolutionValue);
          }
   
          if(optionValue === config.bizFinancing.BTL) { //ESB Hub
            //auto select to BTL
            setSelectedBizFinancing(mData.bizFinanceType.Online);
            calculateEstMonthlyInstallment(SlidervalueMax,interestRateSliderVal);
          }
          else if(optionValue === config.bizFinancing.PBF) {
            setSelectedBizFinancing(mData.bizFinanceType.Personalised);
          }

          setDefaultInitFormData(true,esgSolutionValue);
      
        }
        else {
          //normal flow
          console.log('no option form query string');
          setSelectedBizFinancing(null);
          setIsFromESG(false);
        }
      }
      else {  //Edit from Preview
        setIsEditPreview(true);
        getData();
      }
    }

    const getData = () => {
      setIsLoading(true);
      const paramRefNo = storage.getRefNo();
      service.getformdata(paramRefNo).then(res => {
       
        if (res.data.isSucess) {
          let resData = res.data.model;
    
          if(resData.financingProduct === mData.bizFinanceType.Online) { //BTL
            setSelectedBizFinancing(mData.bizFinanceType.Online);
            bindBTLDataOnEdit(resData);
          }
          else if(resData.financingProduct === mData.bizFinanceType.Personalised) {//PBF
            setSelectedBizFinancing(mData.bizFinanceType.Personalised);
            bindFormData(resData);
          }
          else if(resData.financingProduct === mData.bizFinanceType.AIP) { //AIP
            setSelectedBizFinancing(mData.bizFinanceType.AIP);
            setSelectedRdoExistingOTP(resData.isExistingOTPAvailable);
            bindFormData(resData);
          }
        }
        else {
          showErrMsg("Please try again");
        }
        setIsLoading(false);
      })
        .catch(err => {
          console.log('err=>', err);
          setIsLoading(false);
          showErrMsg(config.error.GetApiFailed);
        })
    }
    
    const bindFormData = (data) => {

      console.log('bindFormData');

      const isWCL = (data.wcl === 'Y')? true:false;
      const isProperty = (data.property === 'Y')? true:false;
      const isTrade = (data.trade === 'Y')? true:false;
      const isGAS = (data.gas === 'Y')? true:false;
      const isESG = (data.esg === 'Y')? true:false;

      const fAmt =data.financingAmount !== ''? parseFloat(data.financingAmount):null;
   
      let ddlPromoRef1 = (data.ddlPromoReferralCode1 ===null ||data.ddlPromoReferralCode1 ==='')? mData.promoReferalDDList[0]:helper.getObjInArray(data.ddlPromoReferralCode1,mData.promoReferalDDList);

      let ddlPromoRef2 = '';
      if(data.ddlPromoReferralCode2 === null || data.ddlPromoReferralCode2 ===''){
        if(ddlPromoRef1.value === 'PromoCode') {
          ddlPromoRef2 = helper.getObjInArray('ReferralCode',mData.promoReferalDDList); // Default to Referal
        }
        else {
          ddlPromoRef2 = helper.getObjInArray('PromoCode',mData.promoReferalDDList); // Default to Promo
        }
      }
      else {
        ddlPromoRef2 = helper.getObjInArray(data.ddlPromoReferralCode2,mData.promoReferalDDList);
      }
    

      let promoReferalValue1Result = '',promoReferalValue2Result='';
      if(data.ddlPromoReferralCode1 === 'PromoCode') {
        promoReferalValue1Result = data.promoCode;
      }
      else if(data.ddlPromoReferralCode1 === 'ReferralCode'){
        promoReferalValue1Result = data.referralCode;
      }

      if(data.ddlPromoReferralCode2 === 'PromoCode') {
        promoReferalValue2Result = data.promoCode;
      }
      else if(data.ddlPromoReferralCode2 === 'ReferralCode'){
        promoReferalValue2Result = data.referralCode;
      }

      if(ddlPromoRef2 !== null && ddlPromoRef2 !== '' && promoReferalValue2Result !== ''){
        setShowPromoReferalDiv2(true);
      }
      else {
        setShowPromoReferalDiv2(false);
      }

      setInitFormData({
        chkWorkingCapital:isWCL,
        chkProperty:isProperty,
        chkTrade:isTrade,
        chkGovAssist:isGAS,
        chkESG:isESG,
        totalFinancingAmtValue:fAmt,
        ddlPromoReferal1:ddlPromoRef1,
        promoReferalValue1:promoReferalValue1Result,
        ddlPromoReferal2:ddlPromoRef2,
        promoReferalValue2:promoReferalValue2Result,
        chkIsamicFtypeDeclare:true
      })

      setSelectedRdoFinancingType(data.financingType);
    }

    const bindBTLDataOnEdit = (resData) => {
      if(resData.financingAmount !== '' && resData.financingAmount !== null ) {

        const financingAmt = parseInt(resData.financingAmount);
        const interRate = parseFloat(resData.indicativeInterestRate);

        setAmountsSliderValueMax(financingAmt);
        setAmountsSliderValueMin(financingAmt);
        setInterestRateVal(interRate);
        setinterestRateSliderVal(interRate);
        calculateEstMonthlyInstallment(financingAmt,interRate);
        setSelectedTenureCard({
          tenure:resData.financingTenure,
          estMonthlyInstallment:resData.indicativeMonthlyInstallment
        });

        bindFormData(resData);
      }
      
    }

    const setDefaultInitFormData = (isEsg, esgFtype) => {
      
      setInitFormData({
        chkWorkingCapital:false,
        chkProperty:false,
        chkTrade:false,
        chkGovAssist:(isEsg && esgFtype===mData.esgSolutionFType.Enterprise)?true:false,
        chkESG:isEsg?true:false,
        totalFinancingAmtValue:null,
        ddlPromoReferal1:mData.promoReferalDDList[0],
        promoReferalValue1:'',
        ddlPromoReferal2:null,
        promoReferalValue2:'',
        chkIsamicFtypeDeclare:false
      })

      if(isEsg) setDisabledRdoFinancingType(false);
    }

    //Events

    const handleRdoExistingOTPChange = useCallback( (e) => {
      // console.log('handleRdoExistingOTPChange',e.value)
      try{
        setSelectedRdoExistingOTP(e.value)
      }catch(e){

      }
  ;
    },[selectedRdoExistingOTP])  

    const handleRdoChange = useCallback( (e) => {
      setSelectedRdoFinancingType(e.value);
    },[selectedRdoFinancingType])  

    const handleSubmit = (dataItem) => {
        // if(dataItem.isValid) {
          let data = JSON.parse(JSON.stringify(dataItem.values));
          setFormData(data);
  
          if(selectedBizFinancing === null) {
              showErrMsg(mData.error.noPrefFinanceSelected);
              return;
          }

          //Biz Financing Selected 
          if(selectedBizFinancing === mData.bizFinanceType.Personalised) { //Hybrid - Flow to BAU
              //Personalised Biz Financing
  
              if(!data.chkGovAssist && !data.chkProperty && !data.chkTrade && !data.chkWorkingCapital && !data.chkESG) {
                showErrMsg(mData.error.noPurposeFinancing);
                return;
              }

              if(data.totalFinancingAmtValue === null) {
                showErrMsg(mData.error.fieldBlank);
                return;
              }

              if(config.ReCaptcha.enable && !isEditPreview && !captchaResult) {
                showErrMsg(mData.error.fieldBlank);
                return;
              }

              //validation pass
              if(isEditPreview) {
                updateFormData(data);
                return;
              }
   
              if(dataItem.isValid) {
                if(data.chkGovAssist) {
                  setShowEnterpriseDeclarePopup(true);
                }
                else {
                  setShowSingpassDeclarePopup(true);
                }
              }
          }
          else if(selectedBizFinancing === mData.bizFinanceType.AIP) { //AIP CIP
       
            if(selectedRdoExistingOTP === null) {
              showErrMsg(mData.error.noOTPSelected);
              return;
            }

            if(selectedRdoExistingOTP === 'Y' && data.totalFinancingAmtValue === null) {
              showErrMsg(mData.error.fieldBlank);
              return;
            }

            if(config.ReCaptcha.enable && !isEditPreview && !captchaResult) {
              showErrMsg(mData.error.fieldBlank);
              return;
            }

            if(isEditPreview) {
              updateFormData(data);
              return;
            }
         
            if(dataItem.isValid) {
              setShowSingpassDeclarePopup(true);
            }
          }
          else if(selectedBizFinancing === mData.bizFinanceType.Online){ //Online Biz Finacing - BTL Existing
       
            if(selectedTenureCard.tenure === '') {
              showErrMsg(mData.error.noTenureSelected);
              return;
            }

            if(config.ReCaptcha.enable && !isEditPreview && !captchaResult) {
              showErrMsg(mData.error.fieldBlank);
              return;
            }

            //validation pass
            if(isEditPreview) {
              updateFormData(data);
              return;
            }
              //first time
                     
            if(dataItem.isValid) {
              setShowSingpassDeclarePopup(true);
            }
          }
        // }
    }

    const handleGetInTouch = (e) => {
        e.preventDefault();
        window.location.href = config.link.GetInTouch;
    }

    const handleEnterpriseDeclareProceed = ()=> {
        setShowEnterpriseDeclarePopup(false);
        setShowSingpassDeclarePopup(true);
    }

    const handleSingpassDeclareProceed = () => {
        setShowSingpassDeclarePopup(false);
        //Api Call 
        postCreateState();
    }

    const handleBTLDeclareProceed = ()=> {
      setShowBtlDeclarePopup(false);
    }

    const handleBTLDeclareClose = () => {
      console.log('handleBTLDeclareClose');
      setSelectedBizFinancing(null);
    }

    const handleHybridDeclareProceed = ()=> {
      setShowHybridDeclarePopup(false);
    }

    const handleHybridLDeclareClose = () => {
      console.log('handleHybridLDeclareClose');
      setSelectedBizFinancing(null);
    }

    const handleAIPDeclareProceed = ()=> {
      setShowAipDeclarePopup(false);
    }

    const handleAIPDeclareClose = () => {
      console.log('handleHybridLDeclareClose');
      setSelectedBizFinancing(null);
    }


    //error msg
    const showErrMsg = (msg) => {
        setIsError(true);
        setErrMsg(msg);
        setErrMsgTimeout();
      }
    
    const setErrMsgTimeout = () => {
        timer = setTimeout(() => {
          setIsError(false);
        }, config.error.msgTimeout);
    }
    //error msg end
    
    //Recaptcha
    function onChangeRecapthcha(value) {

        let cValue = value;
        if(cValue) {
          setCaptchaResult(true);
        }
        else {
         setCaptchaResult(false);
        }
      }
    
      const onRecaptchaErrored = (e) => {
        console.log('@onRecaptchaErrored')
        showErrMsg(config.error.ReCaptchaFailed);
      }
    
      const onAsyncScriptOnLoad = () => {
        console.log('@onAsyncScriptOnLoad')
      }
    
      const onRecaptchaExpired = () => {
        console.log('@onRecaptchaExpired');
        setCaptchaResult(false);
      }
    //Recaptcha end

    //Online Biz Financing Selected Function - STP
    const handleBlur = () => {
 
        if (SlidervalueMax < mData.STPFinancingAmt.min) {
          setAmountsSliderValueMin(mData.STPFinancingAmt.min);
          setAmountsSliderValueMax(mData.STPFinancingAmt.min);
        } else if (SlidervalueMax > maxAmountVal) {
          setAmountsSliderValueMin(maxAmountVal);
          setAmountsSliderValueMax(maxAmountVal);
        } else {
          let vvmath = Math.round(SlidervalueMax / 1000) * 1000;
          if (vvmath) {
            setAmountsSliderValueMin(vvmath);
            setAmountsSliderValueMax(vvmath);
          }
        }
    };

    const handleIRInputBlur = (e) => {
      let irvalue = e.target.value;
      // console.log('handleIRInputBlur', irvalue);
      let vvmath = 8;
      let secDecimal =  Math.floor((irvalue * 100) % 10); //get 2nd decimal
      // console.log('secDecimal: ',secDecimal);
      if(secDecimal <= 4) {
        // vvmath = Math.floor(irvalue * 10) /10; // round down
        vvmath = Math.ceil(irvalue * 20) /20; 
      }
      else if(secDecimal >=6 ){
        vvmath = Math.ceil(irvalue * 10) / 10; // round up
      }
      else {
        vvmath = irvalue.toFixed(2);
      }
      
      if(vvmath < mData.STPInterestRate.min) {
 
        vvmath = mData.STPInterestRate.min;
      }
      else if(vvmath > mData.STPInterestRate.max) {
 
        vvmath = mData.STPInterestRate.max;
      }

      if (vvmath) {
        setInterestRateVal(Number(vvmath));
        setinterestRateSliderVal(Number(vvmath));
      }

      return Number(vvmath);
    }

    const calculateEstMonthlyInstallment = (sliderValue, interestRateSliderValue) => {

        setShowTenureSelection(true);
        const tenure1 = 1, tenure2 = 2, tenure3 = 3, tenure4 = 4, tenure5 = 5;
        let ir1, ir2, ir3, ir4, ir5;

        let pv = sliderValue;
        let np1 = tenure1 * 12;
        let np2 = tenure2 * 12;
        let np3 = tenure3 * 12;
        let np4 = tenure4 * 12;
        let np5 = tenure5 * 12;
    
        // let minPercent = config.Pricing.MinInterestRate / 100;  
        let minPercent = interestRateSliderValue / 100;
        ir1 = minPercent / 12;
        ir2 = minPercent / 12;
        ir3 = minPercent / 12;

        // let maxPercent = config.Pricing.MaxInterestRate / 100;
        let maxPercent = interestRateSliderValue / 100;
        ir4 = maxPercent / 12;
        ir5 = maxPercent / 12;
        
        const estMthInstT1 = MontlyInductiveCalcPMT(ir1, np1, pv).toFixed(2);
        setEstMonthInstT1Value(estMthInstT1);
        const estMthInstT2 = MontlyInductiveCalcPMT(ir2, np2, pv).toFixed(2);
        setEstMonthInstT2Value(estMthInstT2);
        const estMthInstT3 = MontlyInductiveCalcPMT(ir3, np3, pv).toFixed(2);
        setEstMonthInstT3Value(estMthInstT3);
        const estMthInstT4 = MontlyInductiveCalcPMT(ir4, np4, pv).toFixed(2);
        setEstMonthInstT4Value(estMthInstT4);
        const estMthInstT5 = MontlyInductiveCalcPMT(ir5, np5, pv).toFixed(2);
        setEstMonthInstT5Value(estMthInstT5);

        // console.log('selectedTenureCard ',selectedTenureCard);
        if(selectedTenureCard.tenure === mData.tenureType.t1) {
          setSelectedTenureCard({
            tenure: mData.tenureType.t1,
            estMonthlyInstallment: estMthInstT1
          })
        }
        else if(selectedTenureCard.tenure === mData.tenureType.t2) {
          setSelectedTenureCard({
            tenure: mData.tenureType.t2,
            estMonthlyInstallment: estMthInstT2
          })
        }
        else if(selectedTenureCard.tenure === mData.tenureType.t3) {
          setSelectedTenureCard({
            tenure: mData.tenureType.t3,
            estMonthlyInstallment: estMthInstT3
          })
        }
        else if(selectedTenureCard.tenure === mData.tenureType.t4) {
          setSelectedTenureCard({
            tenure: mData.tenureType.t4,
            estMonthlyInstallment: estMthInstT4
          })
        }
        else if(selectedTenureCard.tenure === mData.tenureType.t5) {
          setSelectedTenureCard({
            tenure: mData.tenureType.t5,
            estMonthlyInstallment: estMthInstT5
          })
        }
    }
 
    const MontlyInductiveCalcPMT = (ir, np, pv, fv, type) => {
      
        var pmt, pvif;

        fv || (fv = 0);
        type || (type = 0);
    
        if (ir === 0)
          return -(pv + fv) / np;

        // console.log('pvif ir: ',(1+ir));
        pvif = Math.pow(1 + ir, np);
        // console.log('after math pow pvif',pvif);
        
        pmt = ir * (pv * pvif + fv) / (pvif - 1);
        // console.log('pmt result: ', pmt);
    
        if (type === 1)
          pmt /= (1 + ir);
    
        // console.log('MontlyInductiveCalcPMT',pmt)
        return pmt;
    }

    const getInterestRate = (tValue) => {
      const tenure = parseInt(tValue);
      let rate = mData.STPInterestRate.min.toString();
      if(config.UseFixedInterestRate) {
        /* FSD has changed, using fixed rate  eg. 10
        if (tenure > 1 && tenure <= 3) {
          rate = mData.STPInterestRate.min.toString();
        }
        else if (tenure > 3 && tenure <= 5) {
          rate = mData.STPInterestRate.min.toString();
        }
          */
        rate = mData.STPInterestRate.min;
      }
      else {
        //not using fixed rate, customer inputted rate
        rate = interestRateSliderVal;
      }
      // console.log('getInterestRate: ',rate);
      return rate.toString();
    }
    
    //Online Biz Financing Selected End

    //API Call
    const postSecurity = () => {
        setIsLoading(true);
        service.security().then(res => {
          setIsLoading(false);
          let resData = res.data;
          if (resData) {
            storage.setToken(resData.token);
            storage.setTokenExpiry(resData.tokenExpirationDate);
            storage.setIsAPSavedForm(false);
          }
          })
          .catch(err => { // 500 or error 
            setIsLoading(false);
            showErrMsg('Service is not available.');
          });
      }

    const postCreateState = () => {
    
        setIsLoading(true);
        let browserInfo = require('browser-info');
        const brosweDetails = browserInfo();
        let packageID = '12000';
        servicestate.postState(brosweDetails, packageID).then(res => {
          const datares = res;
          let resData = datares.data.model;
          // console.log('postCreateState', resData);
          if (resData) {
            createdStateRes = {
              stateId: resData.stateId,
              packageId: resData.packageId,
              referenceNo: resData.referenceNo,
              packageName: resData.packageName,
              packageName: resData.packageName,
              appId: resData.appId,
              clientID: resData.clientID,
              clientSecret: resData.clientSecret,
              scope: resData.scope,
              returnURL: resData.returnURL
            }
            storage.setStateId(resData.stateId);
            postFormData(resData);
          }
        })
        .catch(err => {
          console.log('postCreateState error',err);
            setIsLoading(false);
            showErrMsg('Service is not available.');
        });
      }

      
      const updateFormData = (data) => {
        setIsLoading(true);
        
        let fProdDesc = '';
        if(selectedBizFinancing === mData.bizFinanceType.Online) { //STP
          fProdDesc = mData.bizFinanceType.OnlineDesp;
      
        }
        else if(selectedBizFinancing === mData.bizFinanceType.AIP){ //AIP
          fProdDesc = mData.bizFinanceType.AIPDesp;
        }
        else if(selectedBizFinancing === mData.bizFinanceType.Personalised) { //Hybrid
          fProdDesc = mData.bizFinanceType.PersonalisedDesp;
        }

        let postData =
        {
          "referenceNo": storage.getRefNo(),//state api return value
          "financingType": selectedRdoFinancingType,
          "financingProduct": selectedBizFinancing,
          "financingProductDescription": fProdDesc,
          "isExistingOTPAvailable": selectedBizFinancing === mData.bizFinanceType.AIP? selectedRdoExistingOTP:'N',
          "financingAmount": selectedBizFinancing === mData.bizFinanceType.Online? SlidervalueMin:data.totalFinancingAmtValue,
          "financingTenure": selectedTenureCard.tenure !==''? selectedTenureCard.tenure:'', 
          "indicativeMonthlyInstallment": selectedTenureCard.tenure !==''? selectedTenureCard.estMonthlyInstallment:'', 
          "indicativeInterestRate": selectedTenureCard.tenure !==''? getInterestRate(selectedTenureCard.tenure):'', 
          "referralCode":getReferralCodeValue(data), 
          "promoCode": getPromoCodeValue(data),
          "remarks": "",
          "stateId": storage.getStateId(),//state api
          "wcl": data.chkWorkingCapital? 'Y':'N',
          "property": data.chkProperty? 'Y': 'N',
          "trade": data.chkTrade? 'Y':'N',
          "gas": data.chkGovAssist? 'Y':'N',
          "esg": data.chkESG? 'Y':'N',
          "ddlPromoReferralCode1":data.ddlPromoReferal1.value,
          "ddlPromoReferralCode2":data.ddlPromoReferal2 !==null? data.ddlPromoReferal2.value:null,
          "source":getSourceParams(data)
        }

        service.updateformData(postData).then(res => {
          setIsLoading(false);
          if (res.data.isSucess) {
   
            history.push(config.route.Preview);
          }
          else {
            showErrMsg(config.error.SaveApiFailed);
          }
  
        }).catch(err => {
          setIsLoading(false);
          showErrMsg(config.error.SaveApiFailed);
        });
      }

      const postFormData = (respparams) => {
 
        const postData = formatJsonParams(respparams);
        //call api for form data to save
        service.submitformData(postData).then(res => {
          setIsLoading(false);
       
          if (res.data.isSucess) {
            checkStatusAndGoNext(res);
          }
          else {
            showErrMsg(config.error.SaveApiFailed);
          }
        }).catch(err => {
          console.log('err: ',err);
          setIsLoading(false);
          showErrMsg('Service is not available.');
        });
      }

      const formatJsonParams = (respparams) => {

        let fProdDesc = '';
        let financingAmountValue = SlidervalueMax;  //default to stp

        if(selectedBizFinancing === mData.bizFinanceType.Online) { //STP
          fProdDesc = mData.bizFinanceType.OnlineDesp;
          financingAmountValue = SlidervalueMax;
        }
        else if(selectedBizFinancing === mData.bizFinanceType.AIP){ //AIP
          fProdDesc = mData.bizFinanceType.AIPDesp;
          if(selectedRdoExistingOTP === 'Y') {
            financingAmountValue = formData.totalFinancingAmtValue;
          }
          else {
            financingAmountValue = 0;
          }
        }
        else if(selectedBizFinancing === mData.bizFinanceType.Personalised) { //Hybrid
          fProdDesc = mData.bizFinanceType.PersonalisedDesp;
          financingAmountValue = formData.totalFinancingAmtValue;
        }

        let postData =
        {
          "referenceNo": respparams.referenceNo === null ? "" : respparams.referenceNo,//state api return value
          "financingType": selectedRdoFinancingType,
          "financingProduct": selectedBizFinancing,
          "financingProductDescription": fProdDesc,
          "isExistingOTPAvailable": selectedBizFinancing === mData.bizFinanceType.AIP? selectedRdoExistingOTP:'N',
          "financingAmount": financingAmountValue,
          "financingTenure": selectedTenureCard.tenure !==''? selectedTenureCard.tenure:'', 
          "indicativeMonthlyInstallment": selectedTenureCard.tenure !==''? selectedTenureCard.estMonthlyInstallment:'', 
          "indicativeInterestRate": selectedTenureCard.tenure !==''? getInterestRate(selectedTenureCard.tenure):'', 
          "referralCode": getReferralCodeValue(formData), 
          "promoCode": getPromoCodeValue(formData),
          "remarks": "",
          "stateId": respparams.stateId,//state api
          "wcl": selectedBizFinancing === mData.bizFinanceType.Personalised? formData.chkWorkingCapital? 'Y':'N':'N',
          "property": selectedBizFinancing === mData.bizFinanceType.Personalised? formData.chkProperty? 'Y':'N':'N',
          "trade":selectedBizFinancing === mData.bizFinanceType.Personalised? formData.chkTrade? 'Y':'N':'N',
          "gas": selectedBizFinancing === mData.bizFinanceType.Personalised? formData.chkGovAssist? 'Y':'N':'N',
          "esg": selectedBizFinancing === mData.bizFinanceType.Personalised? formData.chkESG? 'Y':'N':'N',
          "ddlPromoReferralCode1":formData.ddlPromoReferal1.value,
          "ddlPromoReferralCode2":formData.ddlPromoReferal2 !==null?formData.ddlPromoReferal2.value:null,
          "source":getSourceParams(formData)
        }
        return postData;
      }

      const getSourceParams = (fData) => {
        let result = '';
        if(isFromESG) {
          result = 'ESG';
        }
        else if(selectedBizFinancing === mData.bizFinanceType.Personalised && fData.chkESG) { //Pure Hybrid 
          result ='ESG Digital';
        }
        return result;
      }

      const getPromoCodeValue = (fData) => {
        let result = '',finalStr= '';
        let ddlPromoRef1Value = fData.ddlPromoReferal1!==null?fData.ddlPromoReferal1.value:'';
        let ddlPromoRef2Value = fData.ddlPromoReferal2!==null?fData.ddlPromoReferal2.value:'';

        if(ddlPromoRef1Value === 'PromoCode') { //PromoCode
          result = fData.promoReferalValue1;
        }
        else if(ddlPromoRef2Value === 'PromoCode') { //PromoCode
          result = fData.promoReferalValue2;
        }

        if(result !== '') {
          finalStr = helper.removeAllSpaces(result);
        }

        return finalStr;
      }

      const getReferralCodeValue = (fData) => {
        let result = '',finalStr= '';
        let ddlPromoRef1Value = fData.ddlPromoReferal1!==null?fData.ddlPromoReferal1.value:'';
        let ddlPromoRef2Value = fData.ddlPromoReferal2!==null?fData.ddlPromoReferal2.value:'';

        if(ddlPromoRef1Value === 'ReferralCode') { //ReferralCode
          result = fData.promoReferalValue1;
        }
        else if(ddlPromoRef2Value === 'ReferralCode') { //ReferralCode
          result = fData.promoReferalValue2;
        }
  
        if(result !== '') {
          finalStr = helper.removeAllSpaces(result);
        }
        
        return finalStr;
      }

      const checkStatusAndGoNext = (res) => {
        if(isEditPreview) {
          history.goBack();
          return;
        }

        storage.setRefNo(res.data.model.referenceNo);
        storage.setIsFirstTime(true);
        storage.setAppStage(config.AppStage.APPSTART);
      
        if (config.SERVER_STATUS === 'UAT' || config.SERVER_STATUS === 'PROD') {
          let clientID = createdStateRes.clientID;
          let scope = createdStateRes.scope;
          let returnURL = createdStateRes.returnURL;
          let packageName = createdStateRes.packageName;
          let appId = createdStateRes.appId;
          let clientSecret = createdStateRes.clientSecret;
          let packageId = createdStateRes.packageId;
          let stateId = createdStateRes.stateId;
    
          let singPassUrL = '';
           
          if(config.SERVER_STATUS === 'UAT') {
            singPassUrL = config.MyInfoGovt.UATBizURL;
          }
          else {
            singPassUrL = config.MyInfoGovt.BizURL;
          }

    
          let paramPass = "?authmode=SINGPASS" +
            "&purpose=" + packageName +
            "&response_type=code" +
            "&attributes=" + scope +
            "&state=" + stateId +
            "&redirect_uri=" + returnURL +
            "&client_id=" + clientID;
    
          window.location.href = singPassUrL + paramPass;
        }
        else { //SIM, DEV, SIT
          history.push('MyInfoLanding?state=' + createdStateRes.stateId);
        }
      }

    const hideFieldsIfAIPOTPNull = () => {
      let result = false;
      if(selectedBizFinancing === mData.bizFinanceType.AIP && selectedRdoExistingOTP === null) {
        result = true;
      }
      return result;
    }
    
    //API Call End

    //reset values upon selection change 
    const resetFormValues = () => {
      // console.log('resetFormValues');
      setInitFormData({
        chkWorkingCapital:false,
        chkProperty:false,
        chkTrade:false,
        chkGovAssist:false,
        chkESG:false,
        totalFinancingAmtValue:null,
        ddlPromoReferal1:mData.promoReferalDDList[0],
        promoReferalValue1:'',
        ddlPromoReferal2:null,
        promoReferalValue2:'',
        chkIsamicFtypeDeclare:false
      })
      setIsLoading(false)
    }

    const resetFields = () => {
      setSelectedRdoExistingOTP(null);
      resetFormValues();
    }

    const disableIslamicFtypeRdo = (wcl,property,trade,gova,esg) => {
      // console.log('disableIslamicFtypeRdo: ',wcl,property,trade,gova,esg)
      if(!wcl && !property && !trade && !gova && !esg) { //nth selected
        
        setDisabledRdoFinancingType(true);
        setSelectedRdoFinancingType(mData.financeTypeRdo.Conventional);
      }
      else if (!wcl && !property && trade && !gova && !esg) { // only trade selected
        setDisabledRdoFinancingType(true);
        setSelectedRdoFinancingType(mData.financeTypeRdo.Conventional);
      }
      else if (!wcl && !property && !trade && gova && !esg) { //only gova selected
        setDisabledRdoFinancingType(true);
        setSelectedRdoFinancingType(mData.financeTypeRdo.Conventional);
      }
      else if(!wcl && !property && trade && gova && !esg) {  //both trade and gova selected
        setDisabledRdoFinancingType(true);
        setSelectedRdoFinancingType(mData.financeTypeRdo.Conventional);
      }
      else {
        setDisabledRdoFinancingType(false);
      }
    }

    return (
        <div className="container-fluid">
            <p className="welcome mb-0 k-align-items-center">
              Hello there! Let's get started
            </p>
            <FormContainerMax>
            <Form
                onSubmitClick={handleSubmit} 
                initialValues={initFormData}
                key={JSON.stringify(initFormData)}
                render={(formRenderProps) => (
                    <FormElement>
                        <fieldset>
                        <FieldWrapper>
                            <Field component={FormTitleHybrid} id={'ft1'} name={mData.formTitle.ft1}/>
                            <Field component={FormSubTitleDespHybrid} id={'ftSub1'} name={mData.formTitleDesc.text}/> 
                            <FieldWrapper>
                              <Field component={HybridFormLabelGrey} labelId={'lblGraySubft1'} labelName={mData.formSubTitle.subft1} />
                            </FieldWrapper>
                        </FieldWrapper>
                        <FieldWrapper>
                          <FinancingSelection isEditForm={(isEditPreview || isFromESG)?true:false}
                            selectedBizCard={selectedBizFinancing}
                            setSelectedBizCard={setSelectedBizFinancing} 
                            onSelect={(v)=> {
                              resetFields();
                              setSelectedBizFinancing(v);
                              if(v === mData.bizFinanceType.Online || v === mData.bizFinanceType.AIP){ //BTL or AIP
                                setDisabledRdoFinancingType(false);
                                if(v === mData.bizFinanceType.Online) setShowBtlDeclarePopup(true);
                                if(v === mData.bizFinanceType.AIP) setShowAipDeclarePopup(true);
                              }
                              else { //Hybrid
                                setDisabledRdoFinancingType(true);
                                setShowHybridDeclarePopup(true);
                              }

                              calculateEstMonthlyInstallment(SlidervalueMax,interestRateSliderVal);
                              formRenderProps.onFormReset();    
                           }} />
                        </FieldWrapper>
                        
                        {!isLoading &&
                        <>
                        {selectedBizFinancing !== null  &&
                        <div className="divgreylineCpf"/>
                        }

                        {selectedBizFinancing === mData.bizFinanceType.Online && 
                            <div>
                                <FieldWrapper>
                                    <BlueboxTextList textList={mData.onlineBlueboxTxtList} />
                                </FieldWrapper>
                                <div className="row around-xs inputPair elementVisible">
                                    <div className='graydiv row around-xs inputPair elementVisible' style={{width:'100%',margin:'2.5%'}}>
                                        <div className="col-xs-12 col-sm-5 col-md-5 col-lg-5">
                                            {'Indicate your desired financing amount'}
                                        </div> 
                                        <div className="col-xs-12 col-sm-7 col-md-7 col-lg-7">
                                            <NumericTextBox
                                                format="c2"
                                                placeholder="S$0"
                                                min={mData.STPFinancingAmt.min}
                                                max={maxAmountVal}
                                                onChange={(event) => {
                                                    let nValue = event.target.value === '' ? '' : Number(event.target.value);
                                                    setAmountsSliderValueMax(nValue);
                                                    setAmountsSliderValueMin(nValue);
                                              
                                                    if(nValue >= mData.STPFinancingAmt.min && nValue <= mData.STPFinancingAmt.max) {
                                         
                                                      calculateEstMonthlyInstallment(nValue, interestRateVal);
                                                    }
                                                    else if(nValue <= mData.STPFinancingAmt.min) {
                                                      calculateEstMonthlyInstallment(mData.STPFinancingAmt.min,interestRateVal);
                                                    }
                                                    else if(nValue >= mData.STPFinancingAmt.max) {
                                                      calculateEstMonthlyInstallment(mData.STPFinancingAmt.max,interestRateVal);
                                                    }
                                                }}
                                                onBlur={handleBlur}
                                                value={SlidervalueMax}
                                                spinners={false} 
                                                step={1000}
                                                />
                                            </div>
                   
                                            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                                <RangeSlider
                                                    min={mData.STPFinancingAmt.min}
                                                    max={maxAmountVal}
                                                    step={1000}
                                                    variant='warning'
                                                    value={typeof SlidervalueMax === 'number' ? SlidervalueMax : mData.STPFinancingAmt.max}
                                                    onChange={(event, newValue) => {
                                                    setAmountsSliderValueMax(newValue);
                                                    setAmountsSliderValueMin(event.target.value === '' ? '' : Number(event.target.value));
                                                    calculateEstMonthlyInstallment(newValue, interestRateVal);
                                                }} />
                                                <div style={{width:'100%'}}>
                                                    <div style={{width:'50%',float:'left'}}>{mData.STPFinancingAmt.minTxt}</div>
                                                    <div style={{width:'50%',float:'right',textAlign:'right'}}>{mData.STPFinancingAmt.maxTxt}</div>
                                                </div>
                                            </div>
                                        </div>
                                </div>
                                {!config.UseFixedInterestRate &&(
                                <>
                                <div className="row around-xs inputPair elementVisible">
                                    <div className='graydiv row around-xs inputPair elementVisible' style={{width:'100%',margin:'2.5%'}}>
                                        <div className="col-xs-12 col-sm-5 col-md-5 col-lg-5">
                                            {'Indicate your desired Financing Rate (%)'}
                                        </div> 
                                        <div className="col-xs-12 col-sm-7 col-md-7 col-lg-7">
                                            <NumericTextBox
                                                format="n2"
                                                placeholder="0.05%"
                                                min={mData.STPInterestRate.min}
                                                max={mData.STPInterestRate.max}
                                                value={interestRateVal}
                                                spinners={false} 
                                                step={0.05}
                                                onBlur={handleIRInputBlur}
                                                onChange={(event) => {
                                                    // console.log('onChange')
                                                    let nValue = event.target.value === '' ? '' : Number(event.target.value);
                                                    nValue = handleIRInputBlur(event);
                                                    if(nValue) {
                                                      calculateEstMonthlyInstallment(SlidervalueMax, nValue);
                                                    }
                                                }}
                                                />
                                            </div>
                   
                                            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                                <RangeSlider
                                                    min={mData.STPInterestRate.min}
                                                    max={mData.STPInterestRate.max}
                                                    step={0.05}
                                                    variant='warning'
                                                    value={typeof interestRateSliderVal === 'number' ? interestRateSliderVal : mData.STPInterestRate.min}
                                                    onChange={(event, newValue) => {
                                                      // console.log('Interest Rate Slider Value Change: ',newValue);
                                                      setinterestRateSliderVal(event.target.value === ''?'': Number(event.target.value));
                                                      setInterestRateVal(newValue);
                                                      calculateEstMonthlyInstallment(SlidervalueMax, newValue);
                                                }} />
                                                <div style={{width:'100%'}}>
                                                    <div style={{width:'50%',float:'left'}}>{mData.STPInterestRate.minTxt}</div>
                                                    <div style={{width:'50%',float:'right',textAlign:'right'}}>{mData.STPInterestRate.maxTxt}</div>
                                                </div>
                                            </div>
                                        </div>
                                </div>
                                </>)}
                                {showTenureSelection &&
                                <FieldWrapper>
                                    <TenureSelection  
                                        monthlyInstallment1={estMonthInstT1Value}
                                        monthlyInstallment2={estMonthInstT2Value}
                                        monthlyInstallment3={estMonthInstT3Value}
                                        monthlyInstallment4={estMonthInstT4Value}
                                        monthlyInstallment5={estMonthInstT5Value}
                                        selectedTenureCard={selectedTenureCard}
                                        setSelectedTenureCard={setSelectedTenureCard}
                                        onSelect={(value)=> {
                                            // console.log('TenureSelection onSelect',value);
                                            setSelectedTenureCard(value);
                                        }}
                                    />
                                </FieldWrapper>                      
                            }
                            </div>
                        }
                      
                        {selectedBizFinancing === mData.bizFinanceType.Personalised && 
                            <PersonalisedBizFinancing fProps={formRenderProps} isEditForm={isEditPreview} isESGSolution={isFromESG} esgSolutionType={esgSolutionFType}
                              onSelect={(wcl,property,trade,gova,esg) => {
                                disableIslamicFtypeRdo(wcl,property,trade,gova,esg);
                              }}
                            />
                        }

                        {selectedBizFinancing === mData.bizFinanceType.AIP && 
                          <div>
                            <FieldWrapper>
                              <BlueboxTextList textList={mData.aipBlueboxTxtList} />
                            </FieldWrapper>
                            <div className="divgreylineCpf" />
                            <FieldWrapper>
                            
                              <div className="fd-txt-margin">
                                <RdoFinancingType name="existingOTP" leftValue='Y' rightValue='N' 
                                  disabled={isEditPreview? true: false}
                                  leftValueLabel="Yes" rightValueLabel="No"
                                  label={mData.label.existOTP} labelDesp={''}
                                  enableTooltip={false}
                                  onChange={handleRdoExistingOTPChange} 
                                  checkedValue={selectedRdoExistingOTP} />
                              </div>
                              {selectedRdoExistingOTP !==null && (
                              <div className="divgreylineCpf" />
                              )}
                           
                            {selectedRdoExistingOTP === 'Y'&& 
                              <TotalFinancingAmt 
                                id={'totalFinancingAmtValue'}
                                name={'totalFinancingAmtValue'}
                                disabled={false}
                                leftLabel={'Total Financing Amount'}
                                descLabel={'Min. S$ 200,000 - Max. S$ 10,000,000'}
                                placeholder={'S$0'}
                                validator={min200KValidator}
                              />
                            }

                            {selectedRdoExistingOTP !==null && (
                              <OTPDisclaimer isExistingOTP={selectedRdoExistingOTP} />
                            )}
                          </FieldWrapper> 
                          </div>
                        } 

                        {!hideFieldsIfAIPOTPNull() &&
                        <> 
                          <div className="divgreylineCpf" />
                          <FieldWrapper>
                          <RdoFinancingType name="RdoFinancingType" leftValue={mData.financeTypeRdo.Conventional} rightValue={mData.financeTypeRdo.Islamic} 
                            disabled={(isEditPreview || disabledRdoFinancingType)? true: false}
                            label={mData.label.rdoFinanceType}
                            leftValueLabel="Conventional" rightValueLabel="Islamic"
                            enableTooltip={true}
                            checkedValue={selectedRdoFinancingType}
                            onChange={handleRdoChange} />
                           
                            {((selectedRdoFinancingType === mData.financeTypeRdo.Islamic) && !disabledRdoFinancingType) &&
                              <ChkIslamicFType disabled={isEditPreview} 
                               />
                            }
                          </FieldWrapper>
                        </>
                        }

                        {!hideFieldsIfAIPOTPNull() &&
                        <>
                        <div className="divgreylineCpf" />
                        <PromoCodeSelection disabled={(selectedBizFinancing ===null)?true: false}
                            fProps={formRenderProps} showProRefDiv2={showPromoReferalDiv2} />
                        </>}

                      </>}

                        {(config.ReCaptcha.enable && !isEditPreview && !hideFieldsIfAIPOTPNull())&& 
                        <div className="row around-xs inputPair elementVisible">
                            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                <div className="k-align-items-center">
                                    <div className="recaptcha-box">
                                    <ReCAPTCHA
                                        className="g-recaptcha"
                                        sitekey={config.ReCaptcha.sitekey}
                                        onChange={onChangeRecapthcha}
                                        onErrored={onRecaptchaErrored}
                                        asyncScriptOnLoad={onAsyncScriptOnLoad}
                                        onExpired={onRecaptchaExpired} /> 
                                    </div>
                                </div>
                            </div>
                        </div>
                        }

                        {!hideFieldsIfAIPOTPNull() &&
                        <>
                        {isEditPreview? 
                          <FieldWrapper>
                            <div className="row around-xs inputPair elementVisible">
                                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                    <div style={{textAlign:'center'}} type={'submit'} >
                                        <Button className="k-button btn btn-success">
                                        {mData.label.btnContinue}
                                        </Button>    
                                    </div>
                                </div>
                            </div>
                        </FieldWrapper>
                        :
                        <FieldWrapper>
                            <div className="row around-xs inputPair elementVisible">
                                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                    <div style={{textAlign:'center'}}>
                                        <Button type={'submit'} className="k-button btn btn-success">
                                          <span className="sccbTxt2 txt-ws-initial">{mData.label.btnSingpass}</span>
                                        </Button>     
                                    </div>
                                </div>
                            </div>
                  
                        </FieldWrapper>
                      }
                      </>}
                 
                        </fieldset>
                    </FormElement>
                )}>
                </Form>
                <br/>
            </FormContainerMax>
            {/* <FormFooter /> */}
            <br/>
            <CusToast className="popUpBox" trigger={isError} setTrigger={setIsError} label={errMsg} timer={timer}  />
 
            <EnterpriseDeclarePopup popupValue={showEnterpriseDeclarePopup} setPopupValue={setShowEnterpriseDeclarePopup} 
                onClickProceed={handleEnterpriseDeclareProceed} />
      
            <SingpassDeclarePopup popupValue={showSingpassDeclarePopup} setPopupValue={setShowSingpassDeclarePopup} 
              onClickProceed={handleSingpassDeclareProceed} />
           
            <BTLDisclaimerPopup popupValue={showBtlDeclarePopup} setPopupValue={setShowBtlDeclarePopup} 
              onClickProceed={handleBTLDeclareProceed}
              OnCloseClick={handleBTLDeclareClose} />

            <HybridDisclaimerPopup popupValue={showHybridDeclarePopup} setPopupValue={setShowHybridDeclarePopup} 
              onClickProceed={handleHybridDeclareProceed}
              OnCloseClick={handleHybridLDeclareClose} />

            <AIPDisclaimerPopup popupValue={showAipDeclarePopup} setPopupValue={setShowAipDeclarePopup} 
              onClickProceed={handleAIPDeclareProceed}
              OnCloseClick={handleAIPDeclareClose} />

            {isLoading && <Loading />}
        </div>
    )
 }

export default MainFinanceDetails